import { GroupTrait } from '@kp/traits/group-trait.model';
import { UserTrait } from '@kp/traits/user-trait.model';

export class Traits {
  constructor(public userTraits?: UserTrait[], public groupTraits?: GroupTrait[]) {}

  deserialize(input: any): Traits {
    if (input == null) {
      return null;
    }

    this.userTraits =
      input.userTraits &&
      input.userTraits.filter((trait) => trait != null).map((trait) => new UserTrait().deserialize(trait));

    this.groupTraits =
      input.groupTraits &&
      input.groupTraits.filter((trait) => trait != null).map((trait) => new GroupTrait().deserialize(trait));
    return this;
  }
}
